import './App.css';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Cookie from './components/Cookie';

import { useEffect } from 'react';
import useAuth from './hooks/useAuth';
import Plans from './components/Plan';
import UserStatsAndReferral from './components/UserStatsAndReferral';
import UserPlans from './components/UserPlans';
import ContractStats from './components/ContractStats';
import { RedirectPopup } from './components/Tutotial';


function App() {
  const { login } = useAuth();

  useEffect(() => {
    login();
    // wallet.ethereum.Contract();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="antialiased w-full mx-auto px-2 app">
      <div className="max-w-6xl mx-auto ">
        <Nav />
        <div className="my-8 md:my-16 p-2 leading-tight text-center text-indigo-700">
          <div className="text-xl md:text-4xl  font-bold tracking-wide md:text-md w-full mx-auto justify-center items-center px-4 py-2 rounded-xl text-md mt-2">
            <span className="underline mx-1">Stake BNB</span> to earn upto <span className="underline mx-1">14%</span> return per day
            <div className="text-sm md:text-lg font-medium mt-1">With capitalization of interest and multi level referrals</div>
          </div>
        </div>
        <ContractStats />
        <Plans />
        {/* <Information /> */}
        <UserStatsAndReferral />
        <UserPlans />
        <Footer />
        <Cookie />
        {RedirectPopup()}
      </div>
    </div>
  );
}

export default App;
